// ---------------------------------------------------------------------------
// The page after connecting an account, on the design system (R13)
//
// Unipile's hosted account linking sends the person back to
// /connected?provider=…&status=… (server/routes/accounts.ts), inside the popup
// the settings page opened; the settings page notices the new account itself.
// The page says what happened and offers to close the window. Its words are
// what they were (tests/dom/connected-page.dom.ts pinned them first):
// status=success is "<LinkedIn|Email> connected", anything else, also no
// parameters, "Connection failed", and any provider but linkedin is "Email".
//
// It holds no state, so it is a template, read from the address when it
// renders. It renders without the console's frame once R12d gives its route
// frame 'none' (decision d2); until then it sits in today's frame.
// ---------------------------------------------------------------------------

import { button } from '../design/button.js';
import { standalonePage } from './standalone-page.js';

export const Connected = () => {
  const params = new URLSearchParams(window.location.search);
  const provider = params.get('provider') === 'linkedin' ? 'LinkedIn' : 'Email';
  const page =
    params.get('status') === 'success'
      ? {
          title: `${provider} connected`,
          description: 'Your account has been successfully linked. You can close this window.',
        }
      : {
          title: 'Connection failed',
          description: `Could not connect your ${provider} account. Please try again from Settings.`,
        };
  return standalonePage(page, button({ onClick: () => window.close() }, 'Close window'));
};
